import React from "react";
import classNames from "classnames";

import { ReactComponent as IconBox } from "../../assets/svg/box.svg";

import "./EmptyState.scss";

export const EmptyState = ({ className }) => (
    <div
        className={classNames(
            "empty-state",
            className
        )}
    >
        <div className="empty-state__content">
            <IconBox className="empty-state__icon" />
            <h2 className="empty-state__title">No results found</h2>
            <p className="empty-state__description">Try adjusting your search or filter to find what you`re looking for.</p>
        </div>
    </div>
);
